<template>
    <div>
    <Nav :isDark.sync="this.isDark" @darkmode="isDark = $event"></Nav>
    <div v-loading="loading">
    <div class="container py-2" :style="{height: this.tableData.length === 0 || loading ? 'calc(100vh - 129px)' : 'auto'}">
        <h1 class="fs-24 text-center mt-2">{{this.type}}数据获取</h1>
        <div class="mt-4 mb-4">
            <div class="d-flex justify-content-between">
                <b>选择联赛：</b>
                <div>
                    <el-radio v-model="radio" label="fb" @input="changeType">足球</el-radio>
                    <el-radio v-model="radio" label="bb" @input="changeType">篮球</el-radio>
                </div>
            </div>
            <div v-if="bbLeagueList.length > 0 && radio == 'bb'" class="my-2">
                <div>
                    <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
                    <el-checkbox-group v-model="checkedLeagueBb" @change="handleCheckedChange">
                        <el-checkbox v-for="(item,index) in bbLeagueList" :label="item" :key="index" class="mt-2">{{item.name}}</el-checkbox>
                    </el-checkbox-group>
                </div>
                <div class="mt-4 text-center">
                    <el-button type="info" v-loading.fullscreen.lock="fullscreenLoading" @click="crawlerBskCheckLeague">获取联赛列表</el-button>
                    <el-button type="primary" v-loading.fullscreen.lock="fullscreenLoading" @click="updateBbLgData">更新联赛数据</el-button>
                    <el-button type="success" v-loading.fullscreen.lock="fullscreenLoading" @click="getMatch(false)">抓取今日数据</el-button>
                    <el-button type="success" v-loading.fullscreen.lock="fullscreenLoading" @click="getMatch(true)">抓取明日数据</el-button>
                    <el-button type="warning" v-loading.fullscreen.lock="fullscreenLoading" @click="getMatch(true)">提前1天抓取明日数据</el-button>
                </div>
            </div>
            <div v-if="fbLeagueList.length > 0 && radio == 'fb'" class="my-2">
                <div>
                    <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
                    <el-checkbox-group v-model="checkedLeague" @change="handleCheckedChange">
                        <el-checkbox v-for="(item,index) in fbLeagueList" :label="item" :key="index" class="mt-2">{{item.name}}</el-checkbox>
                    </el-checkbox-group>
                </div>
                <div class="mt-4 text-center">
                    <el-button type="info" v-loading.fullscreen.lock="fullscreenLoading" @click="crawlerCheckLeague">获取联赛列表</el-button>
                    <el-button type="primary" v-loading.fullscreen.lock="fullscreenLoading" @click="updateFbLgData">更新联赛数据</el-button>
                    <el-button type="success" v-loading.fullscreen.lock="fullscreenLoading" @click="getMatch(false)">抓取今日数据</el-button>
                    <el-button type="warning" v-loading.fullscreen.lock="fullscreenLoading" @click="getMatch(true)">抓取明日数据</el-button>
                    <el-button type="danger" v-loading.fullscreen.lock="fullscreenLoading" @click="getEloRating">抓取最新ELO积分数据</el-button>
                </div>
            </div>
        </div>
        <div class="mt-4">
            <b>抓取的比赛：</b>
        </div>
        <div :class="{'d-none': loading}">
            <!-- <el-button class="mb-3" type="primary" v-loading.fullscreen.lock="fullscreenLoading" @click="getMatch()">重新抓取</el-button> -->
            <div class="d-flex justify-content-between">
                <!-- <b>{{ this.dateTitle }}</b> -->
                <el-date-picker v-model="dateVal" type="date" placeholder="选择日期" format="MM-dd" value-format="yyyy-MM-dd" :editable=true @change="changeDate"></el-date-picker>
                <div>
                    <el-button type="text" @click="reCrawler()" class="fs-12 text-end text-primary">不满意？重新抓取比赛>></el-button>
                    
                </div>
            </div>
            <Edite class="mt-2" :matchdata="this.tableData" :emptyText="this.emptyText" @send-data = "handleData"></Edite>
            <div class="mt-2 text-end">
                <el-button type="primary" v-loading.fullscreen.lock="fullscreenLoading" @click="deleteData">删除数据</el-button>
                <el-button type="primary" v-loading.fullscreen.lock="fullscreenLoading" @click="upLoadData">上传数据</el-button>
            </div>
        </div>
    
    </div>
    </div>
    <Footer></Footer>
    </div>
</template>
<script>
import Edite from '../edite/edite-bsk-match.vue';
import Nav from '../comment/nav.vue'
import Footer from '../comment/footer.vue'
import {changeLeagueName,changeTeamName} from '@/utils/change';
import { dateFormatted } from '@/utils/utils';
import { deleteFbMatches, getBbZsMatches, getFbCheckLeagueUrl, getEloRatingUrl, uploadBbMatches, uploadMatches, getFbLeagueListUrl, getBbLeagueListUrl, getBbCheckLeagueUrl, crawlerTdFbMatchesUrl, crawlerTmFbMatchesUrl, crawlerTdBbMatchesUrl, crawlerTmBbMatchesUrl, crawlerBbLgRankUrl, crawlerFbLgRankUrl, crawlerCheckLeagueUrl, crawlerBbCheckLeagueUrl } from '../../constants/http.config';
import { getFbZsMatches } from '../../constants/http.config';
export default {
    components: { Edite, Nav,Footer },
    inject: ['reload'],
    data() {
        return {
            loading: true,
            fullscreenLoading: false,
            tips: '',
            tableData: [],
            dateTitle: '',
            dateVal:'',
            isDark: false,
            reloadTable: false,
            emptyText: '数据加载中...',
            filters: [],
            isphone: false,
            isIndeterminate: false,
            checkAll: false,
            checkedCount: 0,
            columns: [
                { label: '联赛', prop: 'league' },
                { label: '时间', prop: 'time' },
                { label: '主排名', prop: 'homeRank' },
                { label: '主队', prop: 'home' },
                { label: 'qsda', prop: 'qsda' },
                { label: '客队', prop: 'away' },
                { label: '客排名', prop: 'awayRank' },
                { label: '指数1', prop: 'index1' },
                { label: 'Crow', prop: 'handicap' },
                { label: '指数2', prop: 'index2' },
                { label: '小球', prop: 'small' },
                { label: '大小', prop: 'bigsmall' },
                { label: '大球', prop: 'big' },
                { label: 'id', prop: 'id' },
            ],
            leagueList: [],
            fbLeagueList: [],
            bbLeagueList: [],
            checkedLeague: [],
            checkedLeagueBb: [],
            checkedLeagueList: [],
            selectedData: [],
            checkedBbCrawlerLeague: [],
            radio: 'fb',
            type: '足球'
        }
    },
    mounted() {
        let date = dateFormatted(new Date());
        this.dateVal = date;
        this.getFbLeagueList();
        this.getBbLeagueList();
        // this.getCheckLeague();
        // this.getBbCheckLeague();
        this.validatorData();
        // this.getzs();
        // const currentYear = new Date().getFullYear();
        // console.log('yyyyy',currentYear);
    },
    methods: {
        dateFormatted (date) {
            // const date = new Date();
            const year = date.getFullYear();
            let month = date.getMonth();
            let day = date.getDate();
            month = month < 9 ? '0'+( month + 1) : month + 1;
            day = day < 10 ? '0' + day : day;
            return year + '-' + month+'-' + day;
        },
        //获取篮球联赛列表
        getBbLeagueList(){
            const url = getBbLeagueListUrl;
            fetch(url)
            .then(response => response.json())
            .then(data => {
                // console.log(data.data);
                this.bbLeagueList = data.data;
            }).catch(err=>{
                console.log(err);
            })
        },
        //获取足球联赛列表
        getFbLeagueList(){
            const url = getFbLeagueListUrl;
            fetch(url)
            .then(response => response.json())
            .then(data => {
                // console.log('0000000',data.data);
                for (let index = 0; index < data.data.length; index++) {
                    const elm = data.data[index];
                    if (!elm.isHide) {
                        this.fbLeagueList.push(elm)
                    }
                }
                // this.fbLeagueList = data.data;
                
                // this.checkedLeague = ["墨西联",'德甲','意甲']
            }).catch(err=>{
                console.log(err);
            })
        },
        //验证数据
        validatorData(){
            // console.log('验证数据');
            let date = new Date();
            date.setDate(date.getDate() + 1);
            const today = this.dateFormatted(new Date());
            const tomorrowDate = this.dateFormatted(date);
            // console.log(tomorrowDate);
            
            // 设置目标时间为 10:30 AM
            let targetTime = new Date();
            let currentTime = new Date();
            let date2 = this.dateFormatted(new Date());
            targetTime.setHours(10);
            targetTime.setMinutes(35);
            targetTime.setSeconds(0);
            // 比较当前时间和目标时间
            if (currentTime > targetTime) {
                console.log("当前时间大于 10:35 AM，读取今日数据");
                date2 = this.dateFormatted(currentTime);
            } else {
                console.log("当前时间小于 10:35 AM，读取昨天数据");
                // 将日期减一天
                currentTime.setDate(currentTime.getDate() - 1)
                date2 = this.dateFormatted(currentTime);
                // console.log(dateParams);
            }
            // const url = 'https://api.qsda.net/api/match/today';
            
            this.getLocalData()
        },
        getLocalData(){
            this.loading = true;
            let url = ''
            if (this.type === '足球') {
                // url = '/football/match/' + this.dateVal;
                url = getFbZsMatches + this.dateVal;
            }
            if (this.type === '篮球') {
                // url = '/basketball/match/' + this.dateVal;
                url = getBbZsMatches + this.dateVal;
            }
            fetch(url)
            .then(response => response.json())
            .then(data => {
                if (data.code === 200) {
                    this.tableData = data.data;
                    this.dateTitle = data.data.length > 0 ? data.data[0].date : '';
                    if (this.tableData.length == 0) {
                        this.emptyText = '暂无数据';
                    }else{
                        this.emptyText = '加载中...';
                    }
                    this.loading = false;
                    this.reloadTable = true;
                    // console.log('getLocalData',this.tableData.length);
                    this.getCheckLeague();
                }else{
                    this.loading = false;
                    this.emptyText = '暂无数据';
                }
            }).catch(err=>{
                this.loading = false;
                this.emptyText = '暂无数据';
                this.reloadTable = true;
                console.log('读取数据出错',err);
            })
        },
        //抓取比赛
        getMatch(isTomorrow){
            this.fullscreenLoading = true;
            let url = '';
            if (!isTomorrow && this.type === '足球') {
                url = crawlerTdFbMatchesUrl;
            }
            if (isTomorrow && this.type === '足球') {
                url = crawlerTmFbMatchesUrl;
            }
            if (!isTomorrow && this.type === '篮球') {
                url = crawlerTdBbMatchesUrl;
            }
            if (isTomorrow && this.type === '篮球') {
                url = crawlerTmBbMatchesUrl;
                // '/crawler/basketball/tomorrowafter-match'
            }
            console.log(url);
            
            // const url = 'http://localhost:8888/api/crawler/today';
            fetch(url,{
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                }
            })
            .then(response => response.json())
            .then(data => {
                this.fullscreenLoading = false;
                if (data.code == 200) {
                    this.$notify({
                        title: '抓取成功',
                        message: data.data,
                        type: 'success',    
                        // duration: 0
                    });
                    this.validatorData();
                } else {
                    this.tips = '抓取失败，请检查格式是否正确！';
                    this.$notify.error({
                        title: '抓取失败',
                        message: '未知错误，请重试',
                        // duration: 0
                    });
                }
                console.log(data);
            }).catch(err=>{
                this.fullscreenLoading = false;
                this.$notify.error({
                        title: '抓取失败',
                        message: '连接超时',
                        // duration: 0
                    });
                console.error(err);
            })
        },
        reCrawler(){
            this.tableData = [];
            this.reloadTable =true;
            this.emptyText = '暂无数据';
        },
        tableRowClassName({ rowIndex }) {
            // console.log(rowIndex);
            // 根据行的索引自定义类名
            return this.ishide[rowIndex] ? 'd-none' : '';
        },
        filterTag({value, row, column}) {
            const property = column['property'];
            // console.log(row[property],row[property] === value);
            if (value === '竞足') {
                // 当选择 '竞足' 时，检查 myLeague1 数组中的任何一个值是否与 row[property] 匹配
                const match = this.myLeague1.some(league => row[property] === league);
                return match;
            }else if(value === '北单'){
                // 当选择 '北单' 时，检查 myLeague2 数组中的任何一个值是否与 row[property] 匹配
                const match = this.myLeague2.some(league => row[property] === league);
                return match;
            }else{
                // 重置 ishide 数组
                this.ishide.forEach((_, index) => {
                    this.ishide[index] = false;
                });
                return row[property] === value;
            }
        },
        handleCheckAllChange(val) {
            if (this.type === '足球') {
                this.checkedLeagueList = val ? this.fbLeagueList.map(item => item) : [];
                this.checkedLeague = val ? this.fbLeagueList.map(item => item) : [];
            }
            if (this.type === '篮球') {
                this.checkedLeagueBb = val ? this.bbLeagueList.map(item => item) : [];
            }
            this.isIndeterminate = false;
            // console.log('9999',val,this.checkedLeague);
        },
        handleCheckedChange(value) {
            console.log(value);
            this.checkedCount = value.length;
            if (this.type === '足球') {
                this.checkAll = this.checkedCount === this.fbLeagueList.length;
                this.isIndeterminate = this.checkedCount > 0 && this.checkedCount < this.fbLeagueList.length;
            }
            if (this.type === '篮球') {
                this.checkAll = this.checkedCount === this.bbLeagueList.length;
                this.isIndeterminate = this.checkedCount > 0 && this.checkedCount < this.bbLeagueList.length;
            }
        },
        //更新篮球积分榜数据
        updateBbLgData(){
            // this.fullscreenLoading = true;
            if (this.checkedCount == 0) {
                this.$message.error('请至少选中一个联赛!');
            }else {
                console.log('更新..',this.checkedLeagueBb);
                this.loading = true;
                const url = crawlerBbLgRankUrl;
                fetch(url,{
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(this.checkedLeagueBb)
                })
                .then(response => response.json())
                .then(data => {
                    if (data.code == 200) {
                        this.$notify({
                            title: '抓取成功',
                            message: data.data,
                            type: 'success',    
                            // duration: 0
                        });
                    } else {
                        this.$notify.error({
                            title: '抓取失败',
                            message: '请检查代码',
                            // duration: 0
                        });
                    }
                    console.log(data);
                    this.fullscreenLoading = false;
                    this.loading = false;
                }).catch(err=>{
                    this.fullscreenLoading = false;
                    this.loading = false;
                    this.$notify.error({
                            title: '抓取失败',
                            message: '未知错误，请重试',
                        });
                    console.error(err);
                })
            }
        },
        //更新足球积分榜数据
        updateFbLgData(){
            // console.log('sssss',this.checkedLeague);
            // for (let index = 0; index < this.checkedLeagueList.length; index++) {
            //     for (let i = 0; i < this.fbLeagueList.length; i++) {
                    
            //     }
            // }
            if (this.checkedLeague.length == 0) {
                this.$message.error('请至少选中一个联赛!');
            }else {
                console.log('更新..',this.checkedLeague);
                this.loading = true;
                const url = crawlerFbLgRankUrl;
                fetch(url,{
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(this.checkedLeague)
                })
                .then(response => response.json())
                .then(data => {
                    if (data.code == 200) {
                        this.$notify({
                            title: '抓取成功',
                            message: data.data,
                            type: 'success',    
                            duration: 0
                        });
                    } else {
                        this.$notify.error({
                            title: '抓取失败',
                            message: '请检查代码',
                            duration: 0
                        });
                    }
                    // console.log(data);
                    this.fullscreenLoading = false;
                    this.loading = false;
                }).catch(err=>{
                    this.fullscreenLoading = false;
                    this.loading = false;
                    this.$notify.error({
                            title: '抓取失败',
                            message: '未知错误，请重试',
                        });
                    console.error(err);
                })
            }
        },
        //切换足篮
        async changeType(){
            if (this.radio === 'fb') {
                this.type = '足球';
                this.checkAll = false;
                this.checkedLeague = [];
                this.checkedCount = 0;
                this.tableData = [];
                this.validatorData();
            }else{
                this.type = '篮球';
                this.checkAll = false;
                this.checkedLeagueBb = [];
                this.checkedCount = 0;
                this.tableData = [];
                this.validatorData();
                await this.getBbCheckLeague();
                // for (let index = 0; index < this.checkedBbCrawlerLeague.length; index++) {
                //     for (let i = 0; i < this.leagueList.length; i++) {
                //         const lgname = this.leagueList[i].name;
                //         if (this.checkedBbCrawlerLeague[index] === lgname) {
                //             // this.checkedLeagueList.push(data.data[0].data[index]);
                //             this.checkedLeague.push(this.leagueList[i]);
                //         }
                //     }
                // }
            }
        },
        //获取联赛分类列表（竞足，北单，其他）
        async getCheckLeague(){
            // console.log('getCheckLeague')
            const url = getFbCheckLeagueUrl;
            fetch(url)
            .then(response => response.json())
            .then(data => {
                // console.log('yyyyy',data.data[0].data);
                    for (let index = 0; index < data.data[0].data.length; index++) {
                        for (let i = 0; i < this.fbLeagueList.length; i++) {
                            const lgname = this.fbLeagueList[i].name;
                            if (data.data[0].data[index] === lgname) {
                                // this.checkedLeagueList.push(data.data[0].data[index]);
                                this.checkedLeague.push(this.fbLeagueList[i]);
                            }
                        }
                    }
                // console.log('121212',this.checkedLeagueList.length,this.checkedLeague.length);
            }).catch(err=>{
                console.log(err);
            })
        },
        async getBbCheckLeague(){
            const url = getBbCheckLeagueUrl;
            fetch(url)
            .then(response => response.json())
            .then(data => {
                // console.log('bbbb',data.data[0].data);
                this.checkedBbCrawlerLeague = data.data[0].data;
                    for (let index = 0; index < data.data[0].data.length; index++) {
                        for (let i = 0; i < this.bbLeagueList.length; i++) {
                            // const lgname = this.bbLeagueList[i].name;
                            const id = this.bbLeagueList[i].id;
                            if (data.data[0].data[index].id === id) {
                            // console.log(data.data[0].data[index].id,id);
                                // this.checkedLeagueList.push(data.data[0].data[index]);
                                this.checkedLeagueBb.push(this.bbLeagueList[i]);
                            }
                        }
                    }
                    this.checkedCount = this.checkedLeagueBb.length;
                // console.log('121212',this.checkedLeagueList.length,this.checkedLeague.length);
            }).catch(err=>{
                console.log(err);
            })
        },
        //获取要抓取的联赛
        crawlerCheckLeague(){
            this.loading = true;
            const url = crawlerCheckLeagueUrl;
            fetch(url,{
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(this.checkedLeague)
                })
                .then(response => response.json())
                .then(data => {
                    if (data.code == 200) {
                        this.$notify({
                            title: '抓取成功',
                            message: data.data,
                            type: 'success',    
                            // duration: 0
                        });
                    } else {
                        this.$notify.error({
                            title: '抓取失败',
                            message: '请检查代码',
                            // duration: 0
                        });
                    }
                    console.log(data);
                    this.fullscreenLoading = false;
                    this.loading = false;
                }).catch(err=>{
                    this.fullscreenLoading = false;
                    this.loading = false;
                    this.$notify.error({
                            title: '抓取失败',
                            message: '未知错误，请重试',
                        });
                    console.error(err);
                })
        },
        crawlerBskCheckLeague(){
            this.loading = true;
            const url = crawlerBbCheckLeagueUrl;
            fetch(url,{
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(this.checkedLeagueBb)
                })
                .then(response => response.json())
                .then(data => {
                    if (data.code == 200) {
                        this.$notify({
                            title: '抓取成功',
                            message: data.data,
                            type: 'success',    
                            // duration: 0
                        });
                    } else {
                        this.$notify.error({
                            title: '抓取失败',
                            message: '请检查代码',
                            // duration: 0
                        });
                    }
                    console.log(data);
                    this.fullscreenLoading = false;
                    this.loading = false;
                }).catch(err=>{
                    this.fullscreenLoading = false;
                    this.loading = false;
                    this.$notify.error({
                            title: '抓取失败',
                            message: '未知错误，请重试',
                        });
                    console.error(err);
                })
        },
        //上传数据到服务器
        upLoadData(){
            const date = new Date();
            const type = this.radio;
            this.fullscreenLoading = true;
            // let url = '/football/match/upload/' + type;
            // let url = uploadMatches + '/' + type
            let url = 'https://api.qsda.net/api/football/match/upload' + '/' + type
            if (this.radio === 'bb') {
                url = uploadBbMatches + '/' + type;
            }
            // console.log('upload...',this.radio,this.selectedData);
            let successCount = 0;
            let failtCount = 0;
            const requests = [];
            if (this.selectedData.length ===0) {
                this.fullscreenLoading = false;
                this.$message({
                    showClose: true,
                    type: 'warning',
                    message: '请选中至少一条数据!'
                });
            }else{
                    // console.log(this.selectedData.length);
                    let count = 0
                for (let index = 0; index < this.selectedData.length; index++) {
                    const elm = this.selectedData[index];
                    const no_xG = (elm.hxg === 0 && elm.axg === 0) || (null === elm.hxg || null === elm.axg)
                    // console.log(index, no_xG);
                    if (!no_xG) {
                        count = count + 1;
                        const request = fetch(url,{
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify(elm)
                        })
                        .then(response => response.json())
                        .then(data => {
                            // console.log(data.code);
                            if (data.code === 200) {
                                successCount ++;
                            }else{
                                failtCount ++;
                            }
                        })
                        .catch(err=>{
                            console.log(err);
                            failtCount ++;
                        })
                        requests.push(request);
                    }else{
                        console.log(index,'xg===0');
                    }
                }
                // console.log(count);
                Promise.all(requests).then(() => {
                    // console.log('ccccccc',successCount,failtCount);
                    this.fullscreenLoading = false;
                    this.$notify({
                        title: '上传完成',
                        message: `共${successCount}成功,共${failtCount}失败。`,
                        type: 'success',    
                        duration: 0
                    });
                }).catch(error => {
                    console.error('Error:', error);
                    this.$notify.error({
                        title: '上传失败',
                        message: '上传失败，请重试',
                        duration: 0
                    });
                });
            }
        },
        //删除所选比赛数据
        deleteData(){
            const type = this.radio;
            this.fullscreenLoading = true;
            let successCount = 0;
            let failtCount = 0;
            const requests = [];
            let url = deleteFbMatches + '/' + type
            if (this.radio === 'bb') {
                url = uploadBbMatches + '/'+type;
            }
            // console.log('sel',this.selectedData);
            if (this.selectedData.length ===0) {
                this.fullscreenLoading = false;
                this.$message({
                    showClose: true,
                    type: 'warning',
                    message: '请选中至少一条数据!'
                });
            }else{
                for (let index = 0; index < this.selectedData.length; index++) {
                    const elm = this.selectedData[index];
                    const request = fetch(url,{
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(elm)
                    })
                    .then(response => response.json())
                    .then(data => {
                        // console.log(data.code);
                        if (data.code === 200) {
                            successCount ++;
                        }else{
                            failtCount ++;
                        }
                    })
                    .catch(err=>{
                        console.log(err);
                        failtCount ++;
                    })
                    requests.push(request);
                }
                Promise.all(requests).then(() => {
                    // console.log('ccccccc',successCount,failtCount);
                    this.fullscreenLoading = false;
                    this.$notify({
                        title: '删除完成',
                        message: `共${successCount}成功,共${failtCount}失败。`,
                        type: 'success',    
                        duration: 0
                    });
                }).catch(error => {
                    console.error('Error:', error);
                    this.$notify.error({
                        title: '删除失败',
                        message: '删除失败，请重试',
                        duration: 0
                    });
                });
            }
        },
        getzs(url){
            fetch(url)
            .then(response => response.json())
            .then(data => {
                console.log('909090',data.data.length);
                this.loading = false;
                this.tableData = data.data;
            }).catch(err=>{
                console.log('读取数据出错',err);
            })
        },
        changeDate(){
            // 拆分年月日
            const [year, month, day] = this.dateVal.split('-').map(Number);
            // 手动创建 Date 对象（月份 -1，因为 JS 是 0-11）
            // const updatedAt = new Date(year, month - 1, day, 12, 0, 0); // 00:00:00 北京时间
            // 方案4：当前 UTC 时间 + 选择的日期（推荐：记录真实修改时间）
            const nowUTC = new Date().toISOString();
            const [datePart] = nowUTC.split('T');
            const updatedAt = new Date(`${this.dateVal}T${nowUTC.split('T')[1]}`); // 但需确保格式
            // console.log('要存入 updatedAt 的值:', updatedAt);
            // console.log('ISO 格式（推荐存库）:', updatedAt.toISOString());

            this.tableData = [];
            this.loading = true;
            const urlDate = dateFormatted(updatedAt);
            const url = getFbZsMatches + urlDate;
            // console.log('changeDate...', url);
            // console.log(date,url);
            this.selectedData = [];
            this.getLocalData();
        },
        handleData(data){
            // console.log('父收到数组：', data);
            this.selectedData = data;
        },
        getEloRating(){
            this.loading = true;
            const url = getEloRatingUrl;
            // const url = '/crawler/update/elo'
            fetch(url,{
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                })
                .then(response => response.json())
                .then(data => {
                    if (data.code == 200) {
                        this.$notify({
                            title: 'elo积分抓取成功',
                            message: data.data,
                            type: 'success',    
                            duration: 0
                        });
                    } else {
                        this.$notify.error({
                            title: '抓取失败',
                            message: '请检查代码',
                            duration: 0
                        });
                    }
                    console.log(data);
                    this.fullscreenLoading = false;
                    this.loading = false;
                }).catch(err=>{
                    this.fullscreenLoading = false;
                    this.loading = false;
                    this.$notify.error({
                            title: '抓取失败',
                            message: '未知错误，请重试',
                        });
                    console.error(err);
                })
        }
    }
}
</script>
<style lang="scss" scoped>
    @import '../../assets/sass/global.scss';
</style>